import { MerchantDetails } from 'olo-service';
import { useMerchant } from '.';

export type Status = 'online' | 'closed' | 'paused' | 'offline' | 'loading' | 'hoursError' | 'fetchError'

export type MerchantContext = ReturnType<typeof useMerchant>

export type MerchantState = {
  merchant?: MerchantDetails;
  loading: boolean;
  error?: any;
};

/**
 * Feature Flags Consts
 */

export const COLO_AUTHENTICATION_ENABLED = 'COLO_AUTHENTICATION_ENABLED';
export const PERKS_ENABLED = 'PERKS_ENABLED';
export const APPLE_PAY_V2_ENABLED = 'APPLE_PAY_V2';
export const GIFTCARD_PAY_ENABLED = 'GIFTCARD';
export const CONSUMER_PROFILE_ENABLED = 'CONSUMER_PROFILE_ENABLED';
